export interface FieldOption {
  key: string;
  label: string;
  defaultActive: boolean;
}

export const FIELD_OPTIONS: FieldOption[] = [
  { key: 'categoria', label: 'Categoría', defaultActive: true },
  { key: 'sexo', label: 'Sexo', defaultActive: false },
  { key: 'peso', label: 'Peso', defaultActive: true },
  { key: 'estado', label: 'Estado', defaultActive: false },
  { key: 'prenies', label: 'Preñez (Tacto)', defaultActive: false },
  { key: 'tiene_ternero', label: 'Tiene Cría', defaultActive: false },
  { key: 'ubicacion', label: 'Ubicación', defaultActive: false },
  { key: 'raza', label: 'Raza', defaultActive: false },
  { key: 'edad', label: 'Edad (Dentición)', defaultActive: false },
  { key: 'fecha_nacimiento', label: 'Fecha Nacimiento', defaultActive: false },
  { key: 'renspa', label: 'RENSPA', defaultActive: false },
  { key: 'observaciones', label: 'Observaciones', defaultActive: false },
  { key: 'es_comprado', label: 'Es Comprado', defaultActive: false },
  { key: 'caravana_vieja', label: 'Caravana Vieja', defaultActive: false },
  { key: 'madre', label: 'Madre (caravana)', defaultActive: false },
  { key: 'padre', label: 'Padre (caravana)', defaultActive: false },
];

export const QUICK_LOAD_FIELDS = new Set<string>([
  'categoria',
  'peso',
  'sexo',
  'ubicacion',
]);

export const DEFAULT_ACTIVE_FIELDS = new Set<string>(
  FIELD_OPTIONS.filter(f => f.defaultActive).map(f => f.key)
);

export const ALL_FIELDS = new Set<string>(
  FIELD_OPTIONS.map(f => f.key)
);
